import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import {validatable} from 'components/utils';
import { Reception } from 'api';

class DropDownChonHuongXuLy extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      data: []
    }
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    Reception.actions.getHuongXuLyTCD.request(null, {}).then(res => {
      if (this.refs.chonHXL) {
        if (res.data) {
          if (this.props.type == 'them-moi' || this.props.type == 'chinh-sua') {
            res.data = res.data.filter(item => item.giaTri != 'BO_SUNG_THONG_TIN');
          }
          this.setState({data: res.data});
        } else {
          this.setState({data: []});
        }        
      }
    });
  }
  
  onChange(e) {
    this.props.onChange(e);
  }  

  render() {
    return (
      <DropDown label="Hướng xử lý" options={ this.state.data }
        keyName='giaTri' valueName='ten'
        onChange={ this.onChange.bind(this) }
        placeholder={ this.props.placeholder }
        require={this.props.require}
        selectedValue={this.props.selected}
        bindValidator={this}
        channel="formTaoDon"
        ref="chonHXL"
        isValid = {this.props.isValid}
        name="dropdownChonXuLy"/>
    )
  }
}

DropDownChonHuongXuLy.defaultProps = {
  type: '',
  isValid: false,
  require: false,
  selected: '',
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  }
}

let bindStateToProps = state => {
  return {
  }
}

export default connect(bindStateToProps)(validatable(DropDownChonHuongXuLy));



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chonhuongxuly.jsx